import { EnvironmentProviders, Provider } from '@angular/core';
import {
  provideSoftAppsModule,
  provideSoftAppsRoutes,
  withSoftAppsModuleInfo,
  withSoftAppsModuleTranslation,
} from '@softapps/core';
import { getModuleGroupByName } from '@softline/application';
import { default as de } from '../i18n/de.json';
import { provideWwsArtikelstammGlobals } from './artikelstamm.globals';
import { artikelstammRoutes } from './artikelstamm.routes';
import { SOFTLINE_PERMISSION_ARTIKELSTAMM } from './artikelstamm.shared';
import { WwsArtikelstammConfiguration } from './types/artikelstamm-configuration';

export function provideWwsArtikelstamm(
  config?: WwsArtikelstammConfiguration
): Array<Provider | EnvironmentProviders> {
  return [
    provideSoftAppsModule(
      {
        title: 'Artikelstamm',
        name: 'wws-artikelstamm',
        icon: 'fa-regular fa-database',
        route: '/artikelstamm',
        permission: SOFTLINE_PERMISSION_ARTIKELSTAMM,
        group: getModuleGroupByName('Stammdaten'),
      },
      withSoftAppsModuleTranslation({ de }),
      withSoftAppsModuleInfo({
        library: '@softapps/wws/artikelstamm',
        description: 'Artikelstamm pflegen.',
      })
    ),
    provideSoftAppsRoutes({
      app: artikelstammRoutes,
    }),
    ...provideWwsArtikelstammGlobals(config),
  ];
}
